export const detectUserDevicePlatform = () => {
  if (typeof navigator === 'undefined') return 'windows';

  const userAgent = `${navigator.userAgent || ''} ${navigator.vendor || ''}`;
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  if (/android/i.test(userAgent)) return 'android';
  if (/iPad|iPhone|iPod/i.test(userAgent) || isIPadOS) return 'ios';
  if (/Macintosh|Mac OS X/i.test(userAgent) || /^Mac/i.test(navigator.platform || '')) return 'macos';
  return 'windows';
};
